import DiaryEntryCard, { type DiaryEntryItem } from "./DiaryEntryCard";
import { Card, CardContent } from "@/components/ui/card";

interface DiaryEntryListProps {
  entries: DiaryEntryItem[];
  currentUserId?: string | null;
  isAdmin?: boolean;
  projectId?: string;
  onFileVisibilityChange?: () => void;
  onEdit?: (entry: DiaryEntryItem) => void;
  onDelete?: (entry: DiaryEntryItem) => void;
  onUpload?: (entry: DiaryEntryItem) => void;
}

const EMPTY_MESSAGE = "Nenhuma entrada de diário encontrada";

export default function DiaryEntryList({
  entries,
  currentUserId,
  isAdmin = false,
  projectId,
  onFileVisibilityChange,
  onEdit,
  onDelete,
  onUpload,
}: DiaryEntryListProps) {
  if (entries.length === 0) {
    return (
      <Card>
        <CardContent className="text-center py-12">
          <p className="text-primary-600 dark:text-primary-400">{EMPTY_MESSAGE}</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      {entries.map((entry, index) => (
        <DiaryEntryCard
          key={entry.id}
          entry={entry}
          logNumber={index + 1}
          canEdit={
            isAdmin && !!currentUserId && entry.author.id === currentUserId
          }
          projectId={projectId}
          onFileVisibilityChange={onFileVisibilityChange}
          onEdit={onEdit}
          onDelete={onDelete}
          onUpload={onUpload}
        />
      ))}
    </div>
  );
}
